import type { Catalog } from '..'

export const models: Catalog['models'] = {
  /* shared by every plan row */
  activeConnected: 'Ativo · Conectado',
  connected: 'Conectado',
  notConnected: 'Não conectado',
  connectedAs: 'Conectado como',
  plan: 'Plano',
  connect: 'Conectar',
  useInstead: 'Usar este',
  disconnect: 'Desconectar',
  model: 'Modelo',
  reasoningEffort: 'Esforço de raciocínio',
  failedRetry: 'Não deu certo — tente de novo',

  /* reasoning effort labels (the ids sent to the server stay as they are) */
  effortLow: 'Baixo',
  effortMedium: 'Médio',
  effortHigh: 'Alto',
  effortXhigh: 'Muito alto',
  effortMax: 'Máximo',
  effortLowBlurb: 'O mais rápido e barato — bom para edições pequenas e mecânicas',
  effortMediumBlurb: 'O ajuste do dia a dia. Um bom padrão para trabalho de design',
  effortHighBlurb: 'Mais raciocínio por turno — para layouts que precisam ficar certos',
  effortXhighBlurb: 'O máximo de raciocínio, com os turnos mais lentos e caros',
  effortServerDefault: 'O padrão do servidor',

  /* ModelAccount */
  chatgptSwitchFailed:
    'ChatGPT conectado, mas a troca de provedor falhou. Tente a troca de novo sem precisar entrar outra vez.',
  signInIncomplete: 'Esse login não foi concluído',
  andMore: ' e mais',
  pickModel: 'Escolha um modelo',
  visionNote:
    'Somente texto: este modelo não enxerga capturas de tela, então os designs não são revisados visualmente.',
  noVisualReview: 'sem revisão visual',
  rotateKey: 'Trocar chave',
  keyStoredNote: 'A chave fica guardada no servidor e nunca é mostrada de novo.',
  saving: 'Salvando…',
  saveKey: 'Salvar chave',
  codexPlan: 'Plano Codex',
  codexLede: 'Use os modelos da OpenAI pela sua assinatura do ChatGPT',
  retrySwitch: 'Tentar a troca de novo',
  deviceStep1Before: 'Configuração única: ative a ',
  deviceStep1Bold: 'autorização por código de dispositivo',
  deviceStep1After:
    ' no ChatGPT → Configurações → Segurança. (Em uma conta de workspace, um administrador precisa permitir.)',
  deviceStep2Before: 'Abra',
  deviceStep2After: 'e digite este código:',
  waitingApproval: 'Aguardando aprovação…',
  openVerificationPage: 'Abrir página de verificação',
  useBrowserSignIn: 'Códigos de dispositivo indisponíveis na sua conta? Entre pelo navegador',
  waitingOtherTab: 'Aguardando você aprovar na outra aba…',
  reopenSignIn: 'Reabrir login',
  pasteRedirectInstead: 'Colar a URL de redirecionamento',
  pasteStep1: 'Aprove a conexão na aba que acabou de abrir.',
  pasteStep2Before: 'Você vai cair em uma página ',
  pasteStep2Middle: ' que ',
  pasteStep2Bold: 'não carrega',
  pasteStep2After: ' — isso é esperado.',
  pasteStep3: 'Copie o endereço completo dessa página e cole abaixo.',
  connecting: 'Conectando…',
  finishConnecting: 'Concluir conexão',
  opening: 'Abrindo…',
  openaiKeyTitle: 'Chave de API da OpenAI',
  openaiKeyLede: 'Pague por token na sua própria conta da OpenAI — sem assinatura do ChatGPT',
  openrouterKeyTitle: 'Chave de API do OpenRouter',
  openrouterKeyLede:
    'Uma chave para Kimi, Qwen, GLM, DeepSeek, MiniMax, Gemini e outros — pague por token na sua conta do OpenRouter',
  geminiKeyTitle: 'Chave de API do Gemini',
  geminiKeyLede:
    'Os modelos Gemini do Google, mais a geração de imagens do Nano Banana — pague por token na sua conta do Google AI',
  claudeKeyTitle: 'Chave de API do Claude',
  claudeKeyLede: 'Pague por token na sua conta da Anthropic. Roda no servidor do Doop.',

  /* LocalClaude */
  cliSourceChosen: ', escolhido por você.',
  cliSourceShell: ', o que o seu terminal executa.',
  cliSourceFound: ', a instalação mais recente encontrada.',
  claudePlan: 'Plano Claude',
  claudePlanDesktopAria: 'Plano Claude — app para desktop',
  desktopApp: 'App para desktop',
  claudePlanLede: 'Use sua assinatura do Claude localmente.',
  waitingDesktop: 'Aguardando um desktop conectado.',
  useInDesktop: 'Use este plano no app do Doop para desktop.',
  downloadDesktop: 'Baixar app para desktop',
  claudeDefaultModel: 'Padrão do Claude Code',
  claudeFableBlurb: 'O Fable mais recente que o seu Claude Code conhece — para as tarefas mais difíceis e longas.',
  claudeOpusBlurb: 'O Opus mais recente — para layouts complexos e trabalho exigente de design ou código.',
  claudeSonnetBlurb: 'O Sonnet mais recente — um padrão equilibrado para o design do dia a dia.',
  claudeHaikuBlurb: 'O Haiku mais recente — para edições rápidas e tarefas simples.',
  claudeDefaultBlurb: 'O modelo que estiver configurado no seu Claude Code.',
  claudeEffortLowBlurb: 'O mais rápido — bom para edições pequenas e mecânicas',
  claudeEffortMediumBlurb: 'Um bom ajuste do dia a dia para trabalho de design',
  claudeEffortHighBlurb: 'Mais raciocínio por turno — para layouts que precisam ficar certos',
  claudeEffortXhighBlurb: 'Ainda mais profundo; turnos mais lentos',
  claudeEffortMaxBlurb: 'Todo o raciocínio que ele consegue, com os turnos mais lentos',
  pinnedBlurb: 'Fixado neste id exato de modelo; os aliases acompanham os novos lançamentos sozinhos.',
  installToConnect: 'Instale o Claude Code para conectar.',
  signInToConnect: 'Entre no Claude Code para conectar.',
  claudeModelAria: 'Modelo do Claude',
  installing: 'Instalando…',
  installClaude: 'Instalar Claude Code',
  refresh: 'Atualizar',
  signingIn: 'Entrando…',
  signIn: 'Entrar',
  stopTask: 'Parar tarefa',
  effortDefault: 'Padrão',
  effortDefaultBlurb: 'O que estiver configurado no seu Claude Code',
  pinAria: 'Fixar um id de modelo',
  pinPlaceholder: 'Fixe um id de modelo, ex.: claude-opus-5-20260901',
  pin: 'Fixar',
  updateDoop: 'Atualize o Doop para conectar o Claude.',
  outdatedBefore: 'O Claude Code {version} em ',
  outdatedMiddle: ' é mais antigo que a versão {min} de que o Doop precisa. Rode ',
  outdatedAfter: ' em um terminal, ou {fix}, e depois clique em Atualizar.',
  outdatedChoose: 'escolha outra instalação',
  outdatedRemove: 'remova-o para que o Doop encontre sua instalação mais nova',
  notFoundHere: 'Instalado em algum lugar onde o Doop não procurou?',
  chosenMissingBefore: 'O Claude Code que você escolheu em ',
  chosenMissingAfter: ' não existe mais.',
  usingVersion: 'Usando o Claude Code {version} em',
  using: 'Usando o Claude Code em',
  chooseCli: 'Escolher…',
  useDefault: 'Usar o padrão',
  installGuide: 'Guia de instalação',
  working: 'Trabalhando…',
  lastTaskFailed: 'A última tarefa falhou',

  /* ImageModelCard */
  imageNeedsOpenai:
    'Precisa de uma assinatura do ChatGPT ou de uma chave de API da OpenAI conectada acima (ou de uma chave do servidor).',
  imageNeedsGemini: 'Precisa de uma chave de API do Gemini conectada acima (ou de uma chave do servidor).',
  imageNeedsArk: 'Não configurado neste servidor (o operador define ARK_API_KEY).',
  imageGptBlurb: 'O modelo de imagem da OpenAI — texto bem renderizado e assets de UI confiáveis.',
  imageNanoBananaBlurb: 'O modelo de imagem do Google — cenas fotorrealistas, edição, 4K.',
  imageSeedreamProBlurb: 'O melhor modelo de imagem da ByteDance — qualidade rica, quase pictórica.',
  imageSeedreamLiteBlurb: 'Versão mais rápida e barata do Seedream.',
  imageModelTitle: 'Modelo de imagem',
  imageModelDescription:
    'Com qual modelo o agente desenha as imagens geradas. Ele roda na conta correspondente acima ou na chave deste servidor, se você não conectou nada.',
}
